import { render, staticRenderFns } from "./DropdownLinks.vue?vue&type=template&id=496c16ca&"
import script from "./DropdownLinks.vue?vue&type=script&lang=js&"
export * from "./DropdownLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports